import axios from 'axios';
import { removeSpecialCharacters } from '../../../shared/utils/helpers/string';

interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export async function getAddressData(zipcode: string): Promise<ViaCepResponse> {
  try {
    const response = await axios.get<ViaCepResponse>(
      `https://viacep.com.br/ws/${removeSpecialCharacters(zipcode)}/json/`
    );
    return response.data;
  } catch (error) {
    throw new Error(`Erro ao buscar o CEP: ${error}`);
  }
}
